module.exports = __webpack_public_path__ + "static/img/star.2745d011.png";